<template>
  <div id="index">
    <!-- 头部 -->
    <HeaderTop :headIndex="head_index" ref="header"></HeaderTop>

    <!-- 作品列表 -->
    <div class="activitiesList main">
      <h4 class="list_title flex_between">
        <div>
          作品列表
          <span class="prompt">（为自己喜欢的作品投票吧，一次点赞即为一票）</span>
        </div>
        <button class="return_a flex_center" @click="shutDown">返回活动</button>
      </h4>
      <div class="list_ul">
        <div class="list_li" v-for="(liem, index) in list" :key="index" @click="detailsFun(liem)">
          <div class="li_top flex_start flex_items">
            <i class="cover_img portrait flex_center"><img :src="liem.image" alt="" /></i>
            <span class="li_name">{{ liem.name }}</span>
          </div>
          <h5 class="li_title clamp1">{{ liem.title }}</h5>
          <div class="flex_between li_center">
            <div class="li_center_left clamp3">
              <span class="li_tag flex_center">{{ liem.activity_id }}号</span>
              {{ liem.content }}
            </div>
            <div class="li_center_rigth flex_center">
              <img :src="liem.cover" alt="" />
            </div>
          </div>
          <div class="li_bottom flex_start flex_items">
            <div class="flex_center bottom_button" @click.stop="giveFun(index)">
                <span class="prompt">投票</span>
              <i> <img v-if="liem.is_goods == 0" src="@/assets/img/give.png" alt="">
                <img v-else src="@/assets/img/give_t.png" alt=""></i>
              {{ liem.goods }}
            </div>
            <div class="flex_center bottom_button">
              <i><img src="@/assets/img/pinglunP.png" alt="" /></i>
              {{ liem.comment ? liem.comment : 0 }}
            </div>
          </div>
        </div>

        <div class="complete" v-if="list.length<=0">
            <span v-if="!is_loading"> 加载中</span>
            <span v-else>暂无数据</span>
          </div>
      </div>

      <!-- 作品详情 -->
      <!-- <div class="details_popup" v-if="is_details" @click="detailsShow">
        <activitiesDetails ref="activities_details" :details_id="details_id" class="activitiesDetails">
        </activitiesDetails>
      </div> -->
    </div>
    <!-- 尾部 -->
    <Footer></Footer>
  </div>
</template>

<script>
  import "@/assets/js/currency.js";
  import "@/assets/css/reset.css";
  import "@/assets/css/pcsinaFaceAndEffec.css";
  import HeaderTop from "@/components/assembly/HeaderTop.vue"; //头部模块
  import Footer from "@/components/assembly/Footer.vue"; //尾部模块
  // import activitiesDetails from "@/components/pcActivity/activitiesDetails.vue"; //作品列表
  export default {
    name: "activitiesList",
    data() {
      return {
        is_details: false,
        list: [],
        page: 1,
        details_id: {},
        id: 0,
        head_index: 1, //
        is_loading:false
      };
    },
    computed: {},
    components: {
      // activitiesDetails,
      HeaderTop,
      Footer
    },
    props: {},
    watch: {},
    methods: {
      shutDown() {
        this.$router.go(-1)
      },
      is_judge() {
      if (!this.USER() || this.USER().length == 0) {
          this.$refs.header.promptShow();
          return false;
        }

        return true;
      },
      giveFun(index) {
        let that = this;
        if (!this.is_judge()) {
          return false;
        }
        
        this.$post("activity-goods", {
          activity_id: this.list[index].activity_id,
          member_id: this.USER().id,
        }).then((res) => {
          if (res.data) {
            layer.open({
              content: "点赞成功",
              time: true,
              skin: "msg",
            });
            that.list[index].goods = that.list[index].goods + 1;
            that.list[index].is_goods = 1;
          }
        }).catch(error => {
          layer.open({
            content: error.message,
            time: 2,
            skin: "msg"
          });
        });
      },
      no_details() {
        return false;
      },
      detailsShow() {
        this.is_details = false;
        // document.documentElement.style.overflow = "scroll";
      },
      detailsFun(liem) {
        // if (!this.is_judge()) {
        //   return false;
        // }
        this.$router.push({
          path: "/activitiesDetails",
          query: { id: liem.activity_id },
        });
        // this.is_details = true;
        // this.details_id = liem.activity_id;
        // document.documentElement.style.overflow = "hidden";

      },
      //   获取列表
      getList() {
        let that = this;
        this.is_loading = false;
        if (this.page == 1) {
          this.list = [];
        }
        
        this.$post("activity-lists", {
          limit: 18,
          page: this.page,
          member_id: this.USER().id,
        }).then((res) => {
          that.is_loading = true;
          if (res.data.data) {
            res.data.data.forEach((element, index) => {
              res.data.data[index].cover = element.cover.split(",");
            });
            that.list = that.list.concat(res.data.data);
          }
        });
      },
    },
    created() { },
    mounted() {
      this.head_index = this.$route.query.head_index;
      this.id = this.$route.query.id;
      this.getList();
      if (this._isMobile()) {
        // alert("手机端");
        this.$router.push({ path: '/m_activity', query: { id: this.id } });
      } else {
        // alert("pc端");
        // this.$router.replace('/index');
      }
      let that = this;
      $(window).scroll(function () {
        var scrollTop = $(this).scrollTop();
        var scrollHeight = $(document).height();
        var windowHeight = $(this).height();
        if (scrollTop + windowHeight + 2 >= scrollHeight) {
          that.page++;
          that.getList();
        }
      });
    },
  };
</script>
<style>
</style>
<style scoped>
  #index {
    background: #F4F6F8;
  }

  .main {
    max-width: 1280px;
    min-width: 865px;
    margin: 0 auto;
    width: 1280px;
  }

  .activitiesList {
    min-height: calc(100vh - 178px);
  }
  .prompt{
    font-size:14px;
  }

  /* <!-- 标题 -- >  */
  .list_title {
    height: 80px;
    margin: 10px auto;
    padding: 0 40px;
    line-height: 80px;
    background: #fff;
    border-radius: 10px;
    font-size: 24px;
    color: #2b2b2b;
    box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
  }

  /* 列表 */
  .list_ul {
    width: calc(100% + 16px);
    transform: translateX(-8px);
  }

  .list_li {
    background: #fff;
    width: calc(30% - 18px);
    margin: 14px 7.5px;
    border-radius: 6px;
    padding: 3px 23px;
    display: inline-block;
    transition: all 0.5s ease;
    box-shadow: 10px 0 9px rgba(233, 233, 233, 0.16);
    cursor: pointer;
  }

  .list_li .li_top {
    height: 45px;
  }

  .list_li .li_top .portrait {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    margin-right: 10px;
  }

  .list_li .li_top .li_name {
    font-size: 16px;
    color: #888;
  }

  .li_title {
    font-size: 19px;
    color: #2b2b2b;
    font-weight: bold;
    width: 100%;
    margin: 10px 0;
  }

  .li_center {
    height: 84px;
    padding: 8px 0;
    align-items: flex-start;
  }

  .li_center .li_center_rigth {
    height: 100%;
    width: 121px;
    border-radius: 11px;
    background: #f1f1f1;
    overflow: hidden;
  }

  .li_center .li_center_left {
    font-size: 16px;
    color: #888;
    flex: 1;
    margin-right: 11px;
  }

  .li_center .li_center_left .li_tag {
    min-width: 41px;
    padding: 0 4px;
    height: 22px;
    line-height: 1em;
    color: #fff;
    background: #ec865b;
    border-radius: 11px;
    font-size: 12px;
    color: #fff;
    display: inline-flex;
    margin-right: 4px;
  }

  .li_bottom {
    height: 35px;
    border-top: 1px solid #f7f7f7;
    padding: 0 10px;
  }

  .li_bottom .bottom_button {
    margin-right: 14px;
    font-size: 12px;
    color: #888;
    white-space: nowrap;
  }

  .li_bottom .bottom_button>i {
    width: 15px;
    margin-right: 4px;
  }

  .list_li:hover {
    box-shadow: 2px 2px 16px rgba(0, 0, 0, 0.16);
    transform: translateY(-6px);
  }

  /* 详情弹窗 */
  .details_popup {
    position: fixed;
    top: 0;
    width: 100vw;
    left: 0;
    height: 100vh;
    overflow: hidden;
    background: rgba(255, 255, 255, 0.6);
  }

  .activitiesDetails {
    position: fixed;
    top: 80px;
    left: 50%;
    transform: translateX(-50%);
  }

  .return_a {
    width: 135px;
    height: 35.8px;
    line-height: 35.8px;
    border: 0;
    background: #f24d5b;
    border-radius: 5px;
    color: #fff;
    font-size: 15.7px;
    cursor: pointer;

  }
  .bottom_button .prompt{
    margin-right: 4px;
    font-size: 14px;
    color:#777;
  }
</style>


// WEBPACK FOOTER //
// src/components/pcActivity/activitiesList.vue